import { z } from 'zod'

export const atiradorFormSchema = z.object({
  idclube: z.number({ required_error: 'Clube obrigatorio' }).int().positive('Clube obrigatorio'),
  nome: z.string().min(1, 'Nome obrigatorio').max(150),
  cpf: z.string().min(11, 'CPF invalido').max(14, 'CPF invalido'),
  data_nascimento: z.string().min(1, 'Data de nascimento obrigatoria'),
  email: z.string().email('Email invalido').max(150).optional().or(z.literal('')).transform(v => v || null),
  telefone: z.string().max(20).optional().or(z.literal('')).transform(v => v || null),
  numero_cr: z.string().max(40).optional().or(z.literal('')).transform(v => v || null),
})

export type AtiradorFormData = z.infer<typeof atiradorFormSchema>
